import { PageRoutes } from "../constants/historyGaming";
import Profile from "../pages/Profile/Profile";
import { LevelDetail } from "../pages/LevelDetail";
import MainHeader from "../components/common/MainHeader/MainHeader";
import Friends from "../pages/Friends/Friends";
import { EditProfile } from "../pages/EditProfile";
import { Settings } from "../pages/Settings";
import { Languages } from "../pages/Languages";
import SearchFriends from "../pages/SearchFriends/SearchFriends";
import { Support } from "../pages/Support";
import { Suspense } from "react";
import GamingLoading from "../components/common/GamingLoading/GamingLoading";
import {
  BundleDetail,
  Homepage,
  HomepageOld,
  Rank,
  Shop,
} from "./lazyComponent";
import Videos from "../pages/Videos/Videos";
import SearchVideo from "../pages/SearchVideo/SearchVideo";
import FooterNavigationVodacom from "../components/common/FooterNavigationVodacom/FooterNavigationVodacom";
import NotificationsPage from "../pages/Notifications/Notifications";
import { GuestPage } from "../components/common/GuestPage";
import Onboarding from "../pages/Onboarding/Onboarding";
import { isVodacomVersion } from "../constants/gaming";
import FooterNavigation from "../components/common/FooterNavigation/FooterNavigation";
import GamePlay from "../pages/GamePlay/GamePlay";
import Esport from "../pages/Esports/Esports";
import SetProfile from "../pages/SetProfile/SetProfile";

const DefaultLayout = ({ children }: { children: React.ReactNode }) => (
  <>
    <MainHeader key={window.location.pathname} />
    <Suspense fallback={<GamingLoading />}>{children}</Suspense>
    {isVodacomVersion ? <FooterNavigationVodacom /> : <FooterNavigation />}
  </>
);
const routes = [
  {
    path: PageRoutes.HomePage,
    element: (
      <>
        <MainHeader key={window.location.pathname} />
        {<Homepage />}
      </>
    ),
  },
  {
    path: PageRoutes.Rank,
    element: <DefaultLayout>{<Rank />}</DefaultLayout>,
  },
  {
    path: PageRoutes.Esports,
    element: <DefaultLayout>{<Esport />}</DefaultLayout>,
  },
  {
    path: PageRoutes.Friends,
    element: <DefaultLayout>{<Friends />}</DefaultLayout>,
  },
  {
    path: `${PageRoutes.Shop}`,
    element: <DefaultLayout>{<Shop />}</DefaultLayout>,
  },
  {
    path: `${PageRoutes.GamePlay}/:id`,
    element: <GamePlay />,
  },
  {
    path: `${PageRoutes.VideosVodacom}`,
    element: <DefaultLayout>{<Videos />}</DefaultLayout>,
  },
  { path: PageRoutes.Level, element: <LevelDetail /> },
  { path: PageRoutes.EditProfile, element: <EditProfile /> },
  {
    path: `${PageRoutes.Profile}`,
    element: (
      <>
        <MainHeader key={window.location.pathname} />
        <Profile />
      </>
    ),
  },
  {
    path: `${PageRoutes.Profile}/:userId`,
    element: (
      <>
        <MainHeader key={window.location.pathname} />
        <Profile />
      </>
    ),
  },
  {
    path: `${PageRoutes.BundleDetail}/:bundleId`,
    element: (
      <>
        <MainHeader key={window.location.pathname} />
        <Suspense fallback={<GamingLoading />}>
          <BundleDetail />
        </Suspense>
      </>
    ),
  },
  { path: PageRoutes.Settings, element: <Settings /> },
  { path: PageRoutes.Languages, element: <Languages /> },
  { path: PageRoutes.Search, element: <SearchFriends /> },
  { path: PageRoutes.Faq, element: <Support type="faq" /> },
  { path: PageRoutes.TermsAndConditions, element: <Support type="term" /> },
  { path: PageRoutes.CookiePolicy, element: <Support type="cookie" /> },
  { path: PageRoutes.PrivacyPolicy, element: <Support type="privacy" /> },
  { path: PageRoutes.Videos, element: <Videos /> },
  { path: PageRoutes.SearchVideo, element: <SearchVideo /> },
  { path: PageRoutes.Notifications, element: <NotificationsPage /> },
  {
    path: `${PageRoutes.Apps}/:appId`,
    element: (
      <>
        <MainHeader key={window.location.pathname} />
        <Homepage />
      </>
    ),
  },
  { path: PageRoutes.Onboarding, element: <Onboarding /> },
  { path: PageRoutes.SetProfile, element: <SetProfile /> },
  { path: PageRoutes.Guest, element: <GuestPage /> },
];

export default routes;
